import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { ApparelArticleMasterVersions } from "../../entities/tech-pack-versions/apparel-article-masters-versions.entity";


@Injectable()
export class ApparelArticleMasterVersionsRepo extends Repository<ApparelArticleMasterVersions> {

    constructor(@InjectRepository(ApparelArticleMasterVersions) private apparelArticleMasterRepo: Repository<ApparelArticleMasterVersions>
    ) {
        super(apparelArticleMasterRepo.target, apparelArticleMasterRepo.manager, apparelArticleMasterRepo.queryRunner);
    }

}